import React from 'react';

const IconArrowDown = ({
  className = null,
  style = null
}) => {
  return /*#__PURE__*/React.createElement("svg", {
    className: `icon-arrow-down ${className}`,
    style: { ...style,
      boxSizing: 'content-box'
    },
    viewBox: "0 0 100 100",
    preserveAspectRatio: "none"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 100,0 50,100",
    style: {
      boxSizing: 'content-box'
    }
  }));
};

export default IconArrowDown;